'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'icons';
var width = 512;
var height = 512;
var aliases = ["heart-music-camera-bolt"];
var unicode = 'f86d';
var svgPathData = ['M0 67l0 6.1c0 56.1 75.2 112.1 110.3 135.3 10.8 7.1 24.5 7.1 35.3 0 35.1-23.1 110.3-79.2 110.3-135.3l0-6.1c0-37-30-67-67-67-21.1 0-41 9.9-53.6 26.8l-7.3 9.8-7.3-9.8C108 9.9 88.2 0 67.1 0 30 0 0 30 0 67zM321 389.6c2.3 6.2 8.3 10.4 15 10.4l55.7 0-38.4 89.7c-2.9 6.9-.7 14.9 5.3 19.2s14.3 4 19.9-.9l128-112c5-4.4 6.8-11.4 4.4-17.7S502.7 368 496 368l-55.7 0 38.4-89.7c2.9-6.9 .7-14.9-5.3-19.2s-14.3-4-19.9 .9l-128 112c-5 4.4-6.8 11.4-4.4 17.7z', 'M502.3 4.8c-6.1-4.5-14-5.9-21.2-3.7l-160 48C311 52.1 304 61.4 304 72l0 23.1c0 .6 0 1.2 0 1.8l0 80.6c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48l0-110.1 112-33.6 0 49.2c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48l0-127.1c0-.6 0-1.2 0-1.9L512 24c0-7.6-3.6-14.7-9.7-19.3zM86.5 286.3L74.7 304 48 304c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-112c0-26.5-21.5-48-48-48l-26.7 0-11.8-17.8c-5.9-8.9-15.9-14.2-26.6-14.2l-61.7 0c-10.7 0-20.7 5.3-26.6 14.2zM144 360a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIcons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;